@if (showPaymentModes()) {
  @if ((!isSuccess() && !isError()) || isPaymentModesLoading() || isBankCardsLoading()) {
    <div class="skeleton-item-list">
      @for (i of [].constructor(5); track $index) {
        <div class="skeleton-item"></div>
      }
    </div>
  } @else if (isError() || !paymentModesList().length) {
    <sd-system-message type="warning">менеджер уточнит способ оплаты после оформления заказа</sd-system-message>
  } @else {
    <div class="checkout-section-title">
      <h2 class="m-0 text-b3-m-700 text-md-b1-s-700 text-lg-b1-m-700 color-black">способ оплаты</h2>
      <sd-checkout-validation-error [errorKeys]="['PAYMENT_REQUIRED']"></sd-checkout-validation-error>
    </div>

    @if (isPrepaymentRequired()) {
      <sd-system-message type="warning">
        ваша корзина содержит товары, на которые требуется 100% предоплата
      </sd-system-message>
    }

    <sd-payment-modes-list
      [paymentModesList]="paymentModesList()"
      [bankCardsList]="bankCardsList()"
      [canPayInplace]="canPayInplace()"
      [(activePaymentMode)]="activePaymentMode"
      (bindNewCardClicked)="onClickBindNewCard()"
    ></sd-payment-modes-list>

    @if (activePaymentMode()?.code === 'plait') {
      <sd-payment-schedule></sd-payment-schedule>
    }
  }
}
